import React from 'react';
export const UsageChart = () => {
  // Mock data for the usage chart
  const days = 30;
  const mockData = Array.from({
    length: days
  }, (_, i) => ({
    day: i + 1,
    value: Math.floor(Math.random() * 2) // Random value between 0-1 for daily usage
  }));
  // Calculate the maximum value for scaling
  const maxValue = 2;
  // Calculate cumulative usage
  let cumulativeData = [];
  let runningTotal = 0;
  mockData.forEach((item, index) => {
    runningTotal += item.value;
    cumulativeData.push({
      day: item.day,
      value: runningTotal
    });
  });
  // Add projection line (dotted)
  const projectionData = [];
  const projectionDays = 7;
  const lastValue = cumulativeData[cumulativeData.length - 1].value;
  const dailyAverage = lastValue / days;
  for (let i = 1; i <= projectionDays; i++) {
    projectionData.push({
      day: days + i,
      value: lastValue + dailyAverage * i
    });
  }
  return <div className="w-full h-full flex flex-col" data-id="element-1637">
      <div className="flex-1 relative" data-id="element-1638">
        {/* Y-axis labels */}
        <div className="absolute left-0 top-0 h-full flex flex-col justify-between text-xs text-gray-500" data-id="element-1639">
          <div data-id="element-1640">5</div>
          <div data-id="element-1641">4</div>
          <div data-id="element-1642">3</div>
          <div data-id="element-1643">2</div>
          <div data-id="element-1644">1</div>
          <div data-id="element-1645">0</div>
        </div>
        {/* Chart grid */}
        <div className="absolute left-6 right-0 top-0 h-full" data-id="element-1646">
          {[0, 1, 2, 3, 4, 5].map(i => <div key={i} className="absolute border-t border-gray-200 w-full" style={{
          top: `${100 - i * 20}%`
        }} data-id="element-1647"></div>)}
        </div>
        {/* Actual usage bars */}
        <div className="absolute left-6 right-0 bottom-0 h-full flex items-end" data-id="element-1648">
          {mockData.map((item, index) => <div key={index} className="flex-1 flex flex-col justify-end items-center group" data-id="element-1649">
              <div className="w-3 bg-gray-700" style={{
            height: `${item.value / maxValue * 100}%`,
            minHeight: item.value > 0 ? '4px' : '0'
          }} data-id="element-1650"></div>
              {/* Tooltip on hover */}
              <div className="absolute bottom-full mb-2 bg-white border border-gray-200 px-2 py-1 rounded text-xs shadow-sm opacity-0 group-hover:opacity-100 pointer-events-none" data-id="element-1651">
                Day {item.day}: {item.value} invocation
                {item.value !== 1 ? 's' : ''}
              </div>
            </div>)}
        </div>
        {/* Cumulative usage line */}
        <svg className="absolute left-6 right-0 top-0 h-full overflow-visible" data-id="element-1652">
          <polyline points={cumulativeData.map((item, index) => {
          const x = index / (days - 1) * 100;
          const y = 100 - item.value / 5 * 100;
          return `${x}% ${y}%`;
        }).join(' ')} fill="none" stroke="#4B5563" strokeWidth="2" strokeLinejoin="round" strokeLinecap="round" data-id="element-1653" />
          {/* Projection line (dotted) */}
          <polyline points={[...cumulativeData.slice(-1).map((item, index) => {
          const x = (days - 1) / (days - 1) * 100;
          const y = 100 - item.value / 5 * 100;
          return `${x}% ${y}%`;
        }), ...projectionData.map((item, index) => {
          const x = (days - 1 + index + 1) / (days - 1) * 100;
          const y = 100 - item.value / 5 * 100;
          return `${x}% ${y}%`;
        })].join(' ')} fill="none" stroke="#9CA3AF" strokeWidth="2" strokeDasharray="4 4" strokeLinejoin="round" strokeLinecap="round" data-id="element-1654" />
          {/* Current usage indicator dot */}
          <circle cx={`${(days - 1) / (days - 1) * 100}%`} cy={`${100 - cumulativeData[cumulativeData.length - 1].value / 5 * 100}%`} r="4" fill="#4B5563" data-id="element-1655" />
        </svg>
        {/* Limit line */}
        <div className="absolute left-6 right-0 border-t-2 border-dashed border-gray-400 flex justify-end items-center" style={{
        top: '0%'
      }} data-id="element-1656">
          <span className="bg-white px-1 text-xs text-gray-600 mr-1" data-id="element-1657">
            Monthly Limit (5)
          </span>
        </div>
      </div>
    </div>;
};